import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery, useQueryClient } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { PRODUCT_CARDS_QUERY } from '#client/queries/productCards';

export function useProductCards(categorySlug) {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, error, loading, refetch } = useQuery(PRODUCT_CARDS_QUERY, {
    noThrow: true,
    variables: {
      filter: {
        businessEntityUuid,
        ...(categorySlug && { categorySlug }),
      },
    },
  });

  useError(error);

  return {
    data: data?.productCardsV2 || { cards: [], categories: [] },
    error,
    loading,
    refetch,
  };
}

export function useProductCardsCache(categorySlug) {
  const client = useQueryClient();
  const { businessEntityUuid } = useBusinessEntity();

  const query = PRODUCT_CARDS_QUERY;
  const variables = {
    filter: {
      businessEntityUuid,
      ...(categorySlug && { categorySlug }),
    },
  };

  const cachedEntry = client.cache.readQuery({
    query,
    variables,
    operationName: 'ProductCardsV2',
  });

  return cachedEntry?.data?.productCardsV2 ?? null;
}
